import React, { useState, useEffect } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import { fetchMuthootbranches } from "features/disputes/MuthootDisputes/service";

export default function SearchAutocomplete({ value, onChange, label = 'Branch', placeholder = 'Search...', isBeforeLoginFlow = false, required = false, disabled = false}) {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!inputValue) {
      setOptions([]);
      return;
    }

    const URL = isBeforeLoginFlow ? `api/disputes/branchesanonymous/` : `api/disputes/branches/`;

    const timeoutId = setTimeout(() => {
      setLoading(true);

      fetchMuthootbranches(URL, inputValue)
        .then((res) => {
          setOptions(res?.branches.flat()); // must be an array
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 400); // debounce

    return () => clearTimeout(timeoutId);
  }, [inputValue]);

  return (
    <Autocomplete
      value={value}
      options={options}
      loading={loading}
      disabled={disabled}
      getOptionLabel={(option) => {
        if (!option || typeof option !== "object") return "";
        return `${option.br_code} - ${option.branch_name} - ${option.district}`;
      }}
      filterOptions={(x) => x} // disable client-side filtering
      onInputChange={(event, value, reason) => {
        if (reason === "input") {
          setInputValue(value);
        }
      }}
      onChange={(e, value) => onChange(e, value)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          variant="outlined"
          required={required}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      PaperComponent={(props) => (
        <div
          {...props}
          style={{
            ...props.style,
            borderRadius: '4px',
            boxShadow: '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
            background: 'white',
          }}
        />
      )}
      slotProps={{
        listbox: {
          style: {
            maxHeight: 'calc(100% - 200px)',
          }
        }
      }}
    />
  );
}
